import ChatService from "../../../../../front-services/ChatService";
import Colors from "../../../../../utils/Colors";

export default function ShortcutButton({
  assistantChatConfiguration,
  userMessage,
  label,
  style,
  handleShortcutClick,
  assistantId,
  isWhatsapp = false,
}: any) {
  const handleClickArg = isWhatsapp
    ? assistantChatConfiguration.phoneNumber
    : userMessage;
  const _label = isWhatsapp ? "Whatsapp" : label;

  return (
    <button
      className={
        ChatService.isHM(assistantId)
          ? "message-template-cta-button align-text-left"
          : "shortcut-button"
      }
      style={{
        color: ChatService.isHM(assistantId)
          ? ""
          : Colors.lightenHexColor(style.color, 10),
        marginTop: isWhatsapp ? "10px" : "0px",
      }}
      onClick={() => handleShortcutClick(handleClickArg)}
    >
      {isWhatsapp && (
        <>
          <i className="fab fa-whatsapp" style={{ fontSize: "1rem" }}></i>{" "}
        </>
      )}
      {_label}
      {ChatService.isHM(assistantId) && (
        <i className="fa-solid fa-chevron-right"></i>
      )}
    </button>
  );
}
